import { toast } from "react-toastify";
import { commonToast } from "../Utils";
import urls from "../Utils/urls";
import { useDispatch } from "react-redux";
import { setRefreshBankingDetails } from "../store/reducers/accountSlice";
import axios from "../axios";
import { loadingTypes } from "../Utils/constant";

const useDeleteBankAccount = () => {
  const dispatch = useDispatch();

  async function deleteBankAccount(id, setStatus) {
    try {
      const res = await axios.get(urls.borrower.deleteBankAccount(id), {
        headers: {
          Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
        },
      });

      if (res.status == 204) {
        dispatch(setRefreshBankingDetails(true));
        if (setStatus) {
          setStatus(loadingTypes.idle);
        }
        toast.success("Successfully deleted account", {
          ...commonToast,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(`Delete operation failed!`, {
        ...commonToast,
      });
    }
  }

  return { deleteBankAccount };
};

export default useDeleteBankAccount;
